import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SelectedCurrencyOptions } from 'app/model/currencyoptions';
import { Router,ActivatedRoute } from '@angular/router';
import { Dates } from 'app/core/utils/dates';

import { CashDifferenceService } from './cash-difference.service';
import { TellerGlobalServiceService } from 'app/shared/teller-data/teller-global-service.service';
import { SettingsService } from 'app/settings/settings.service';
import { DialogHelper } from 'app/core/utils/dialog-helper';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { OTPRequestData } from 'app/model/tillotp';

@Component({
    selector: 'mifosx-cash-difference',
    templateUrl: './cash-difference.component.html',
    styleUrls: ['./cash-difference.component.scss']
})
export class CashDifferenceComponent implements OnInit,OnDestroy {
    cashDifferenceForm: FormGroup;
    currencyOptions: SelectedCurrencyOptions;
    selectedTeller: any;
    transactionTypeOptions = [
        {value: 'SOBRANTECAJA', displayName: 'Sobrante Caja' },
        {value: 'FALTANTECAJA', displayName: 'Faltante Caja' }
    ];
    minDate = new Date(2000, 0, 1);
    maxDate = new Date();

    /**Subscription to teller data */
    tellerSub: Subscription;

      /** Handle transaction approval */
    approvalDialogRef: Observable<any>;
    approvalData = {};

    constructor(private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private cashDifferenceService: CashDifferenceService,
        private router: Router,
        private tellerGlobalService: TellerGlobalServiceService,
        private settingsService: SettingsService,
        private dateUtils: Dates,
        private matDialog: MatDialog,
        private dialogHelper: DialogHelper) { }

    ngOnInit(): void {
        this.cashDifferenceForm = this.formBuilder.group({
            'currencyCode': ['',Validators.required],
            'amount': ['', Validators.required],
            'transactionType': ['', Validators.required],
            'txnDate': [new Date(), Validators.required]
        });
        this.tellerSub = this.tellerGlobalService.getSelectedTeller$().subscribe(data => this.selectedTeller = data);
        this.route.data.subscribe(({supportedCurrencies}) => {
            this.currencyOptions = supportedCurrencies;
        })
    }

    ngOnDestroy(): void {
        if(this.tellerSub){
            this.tellerSub.unsubscribe();
        }
    }

    submit() {

        const data = {
            "adjustmentType": this.cashDifferenceForm.value.transactionType,
            "currencyCode": this.cashDifferenceForm.value.currencyCode,
            "txnAmount": this.cashDifferenceForm.value.amount,
            "locale": this.settingsService.language.code,
            "txnDate": this.dateUtils.formatDate(this.cashDifferenceForm.value.txnDate, this.settingsService.dateFormat),
            "dateFormat": this.settingsService.dateFormat,
            ...this.approvalData
        };
    
        this.approvalData = {};
        this.cashDifferenceService.adjustCashDifferences(this.selectedTeller['id'], data).subscribe(res => {
            
            if(res.hasOwnProperty('httpStatusCode') && res.httpStatusCode === '202' && res.userMessageGlobalisationCode == 'response.msg.approval.required')
            { 


                const amount = this.cashDifferenceForm.get('amount').value;
                const currencyCode =  this.cashDifferenceForm.get('currencyCode').value;
                const otpRequestData: OTPRequestData = {
                    requestAmount:  amount,
                    entityId: this.selectedTeller['id'],
                    title: `Approve ${this.cashDifferenceForm.get('transactionType').value} of ${amount} ${currencyCode}`
                }
                
                this.approvalDialogRef = this.dialogHelper.showApprovalDialog(otpRequestData,this.matDialog).afterClosed();
                this.approvalDialogRef.subscribe(result => {

                if(result && result.hasOwnProperty('approvalToken')){
                    this.approvalData = result;
                    this.submit();
                }

                });
            }else {
                    this.router.navigate(['/home'], { relativeTo: this.route });
            }
        });
        
    }
}
